import * as TYPES from './types';

export const patientNotifyPreferenceLoaded = (patientNotifyPreference) =>
  ({
    type: TYPES.APPOINTMENTS_PATIENT_NOTIFY_PREFERENCE_LOADED,
    patientNotifyPreference,
  });

export const appointmentsFiltered = (filter) => ({
  type: TYPES.APPOINTMENTS_FILTERED,
  filter,
});

export const userPreferenceLoaded = (filterPref) => ({
  type: TYPES.APPOINTMENTS_USER_PREFERENCE_LOADED,
  filter: filterPref,
});

export const setSortField = (property, sortDirection) => ({
  type: TYPES.APPOINTMENTS_SORTED,
  sortOption: {
    field: property,
    direction: sortDirection,
  },
});

export const appointmentsLoaded = (response, patientFacility) => ({
  type: TYPES.APPOINTMENTS_LOADED,
  appointments: response,
  facility: patientFacility,
});

export const toggleFilterPanel = (showFilterPanel) => ({
  type: TYPES.APPOINTMENTS_TOGGLE_FILTER_PANEL,
  showFilterPanel,
});

export const upcomingAppointmentsLoaded = (appts, patientFacility) => ({
  type: TYPES.UPCOMING_APPOINTMENTS_LOADED,
  upcomingAppointments: appts,
  facility: patientFacility,
});

export const upcomingAppointmentsLoadFailed = () => ({
  type: TYPES.UPCOMING_APPOINTMENTS_LOAD_FAILED,
  upcomingAppointments: [],
});